import { createFileRoute } from '@tanstack/react-router'
import { JSONTree } from '~/elements'
import { messageQueryOptions } from '~/queries'

export const Route = createFileRoute(
  '/workspaces/$workspaceId/bots/$botId/conversations/$conversationId/messages/$messageId'
)({
  component: Component,
  loader: ({ context, params }) => {
    const { messageId, botId, workspaceId } = params
    return context.queryClient.ensureQueryData(messageQueryOptions({ messageId, botId, workspaceId }))
  },
})

function Component() {
  const data = Route.useLoaderData()
  return <JSONTree data={data.message} hideRoot />
}
